import _ from 'lodash';
import React from 'react';
//import {SimpleMenu} from 'rmwc';
import {Checkbox} from 'rmwc';

export default class Filter extends React.PureComponent {
    componentDidMount() {
        const preventClose = async event => {
            if (event.defaultPrevented)
                return;
            if (this.props.isOpen && !this.menuElement.contains(event.target)) {
                event.preventDefault();
                event.stopPropagation();
                // await window.wait();
                this.props.close();
            }
        };
        document.body.addEventListener('click', preventClose, true);
        this.cleanUp = () => {
            document.body.removeEventListener('click', preventClose, true);
        };
    }

    componentWillUnmount() {
        this.cleanUp();
    }

    render() {
        const values = this.props.component
            ? this.props.component
            : _.map(this.props.values, (value, key) => {
                var filter;
                if (this.props.values instanceof Array ||
                    typeof this.props.values === 'string') {
                    if (value instanceof Array) {
                        filter = value[0];
                    }
                    else {
                        filter = value;
                    }
                }
                else {
                    filter = key;
                    filter = filter.toString();
                }
                return <div key={value}>
                    <Checkbox
                        checked={_.includes(this.props.values, filter)}
                        onChange={this.updateValues}>
                        {value instanceof Array ? value[1] : value}
                    </Checkbox>
                </div>;
            });
            return <li style={styles}>
            <div
                ref='filterHeader'
                style={{cursor: 'pointer'}}
                {...(this.props.isOpen ? {} : {onClick: () => this.props.openFilter()})}>
                {this.props.label}
            </div>
            <div
            // It was a SimpleMenu
                ref={component => this.menuElement = component}
                style={{
                    ...styles.filter,
                    ...styles.filter[this.props.size],
                    display:this.props.isOpen?'block':'none',
                    zIndex:1
                }}
                open={this.props.isOpen}
                onClose={this.props.close}>
                {values}
            </div>
            <div>
                <ul style={{padding: 0}}>
                    {_.map(this.props.selected, (item, index) => <li
                        key={index}
                        style={styles.filter.selected}>
                        {this.props.remove
                            ? <i
                                style={{float: 'right', cursor: 'pointer', margin: '.25em'}}
                                onClick={() => {
                                    if (this.props.remove.bind(this))
                                        this.props.remove.bind(this)(index);
                                }}
                                className='fa-times'>
                            </i>
                            : null
                        }
                        {item}
                    </li>)}
                </ul>
            </div>
        </li>;
    }
}

const styles = {
    padding: '.75em 1.5em',
    position: 'relative',
    listStyleType: 'none',
    color: 'black',
    a: {
        color: '#999999',
    },
    filter: {
        width: '20em',
        backgroundColor: 'white',
        position: 'absolute',
        right: '50%',
        top: '-.5em',
        big: {
            minWidth: '40em',
        },
        huge: {
            minWidth: '59em',
        },
        items: {
            color: 'black',
        },
        selected: {
            listStyleType: 'none',
            padding: '0',
            marginRight: '-1em',
            fontSize: '.9em',
            color: '#999999',
            cursor: 'default',
        },
    },
};
